export const loadMarkdown = async (fileName) => {
  const response = await fetch(`${process.env.PUBLIC_URL}/posts/${fileName}`);
  const text = await response.text();
  return text;
};